export const materia = [
  'MatemÃ¡tica',
  'Lengua',
  'Literatura',
  'Lengua y Literatura',
  'Lenguas Adicionales',
  'InglÃ©s',
  'Ciencias Naturales',
  'BiologÃ­a',
  'FÃ­sico - QuÃ­mica',
  'Fisica',
  'QuÃ­mica',
  'Artes Visuales',
  'Italiano',
  'FrancÃ©s',
  'PortuguÃ©s',
  'AlemÃ¡n',
  'Chino',
  'FormaciÃ³n para la vida y el trabajo',
  'Ciencias Sociales',
  'GeografÃ­a',
  'Historia',
  'EducaciÃ³n FÃ­sica',
  'EducaciÃ³n TecnolÃ³gica',
  'FormaciÃ³n Ãtica y Ciudadana',
  'MÃºsica',
  'Teatro',
  'PlÃ¡stica',
  'Danza'
];

export const nivel = [
  'Primario - 1',
  'Primario - 2',
  'Primario - 3',
  'Primario - 4',
  'Primario - 5',
  'Primario - 6',
  'Primario - 7',
  'Secundario - 1',
  'Secundario - 2',
  'Secundario - 3',
  'Secundario - 4',
  'Secundario - 5'
];

export const ejes = [
  'NÃºmeros y Ãlgebra',
  'Funciones y Ãlgebra',
  'GeometrÃ­a y Medida',
  'EstadÃ­stica y Probabilidades',
  'PrÃ¡cticas del Lenguaje en relaciÃ³n con la Literatura ',
  'PrÃ¡cticas del Lenguaje y participaciÃ³n ciudadana',
  'PrÃ¡cticas del Lenguaje en contextos de estudio de la literatura y el lenguaje',
  'Herramientas de la lengua. Uso y reflexiÃ³n',
  'Ãmbitos de uso de la lengua adicional',
  'ReflexiÃ³n acerca del lenguaje',
  'ReflexiÃ³n acerca de aspectos interculturales ',
  'Seres vivos, unidad y diversidad',
  'Panorama general de la reproducciÃ³n',
  'La diversidad de los seres vivos',
  'ProducciÃ³n',
  'ContextualizaciÃ³n',
  'ApreciaciÃ³n',
];

export const contenidos = [
  'NÃºmeros Naturales',
  'NÃºmeros Enteros',
  'NÃºmeros Racionales positivos',
  'NÃºmeros racionales',
  'NÃºmeros Naturales',
  'FunciÃ³n lineal',
  'EcuaciÃ³n de la recta',
  'Proporcionalidad inversa',
  'TriÃ¡ngulos',
  'CuadrilÃ¡teros',
  'Comentario de textos ',
  'Comentario de obras literarias',
  'Comunidad de lectores',
  'ProducciÃ³n y escucha de narraciones orales',
  'Recursos y procedimientos del discurso, el texto y la oraciÃ³n' ,
  'Modos de organizaciÃ³n del discurso',
  'LÃ©xico',
  'OrtografÃ­a',
  'Lectura de textos',
  'Lectura exploratoria para la bÃºsqueda de informaciÃ³n',
  'Lectura detenida de textos de estudio ',
  'Escritura',
  'Escritura de obras ficcionales',
  'Escritura de recomendaciones de obras leÃ­das',
  'AnÃ¡lisis de textos',
  'PrevenciÃ³n sobre las Adicciones y el Consumo Indebido de Drogas',
  'EducaciÃ³n Sexual Integral',
  'EducaciÃ³n Digital',
  'Nivel A',
  'Nivel B',
  'Escucha de textos orales',
  'ProducciÃ³n de textos orales',
  'Oralidad',
  'Lectura de textos escritos',
  'ProducciÃ³n escrita de textos',
  'Aspectos LingÃ¼Ã­sticos',
  'FonologÃ­a',
  'GramÃ¡tica',
  'Aspectos pragmÃ¡tico-discursivos',
  'Aspectos lingÃ¼Ã­sticos',
  'CaracterizaciÃ³n de los seres vivos',
  'Concepto de sistema',
  'Unidad y diversidad de funciones y estructuras',
  'Ãrboles de parentesco entre los seres vivos',
  'El origen de la vida',
  'Continuidad de la vida. TeorÃ­a celular',
  'Niveles de organizaciÃ³n de la materia',
  'Biodiversidad: aspectos evolutivos',
  'Origen de cÃ©lulas eucariotas',
  'TeorÃ­a endosimbiÃ³tica',
  'Concepto general de cÃ©lula procariota y eucariota',
  'Origen de la multicelularidad',
  'Sistemas reproductores',
  'GestaciÃ³n, embarazo, parto, puerperio',
  'Pubertad y la adolescencia',
  'Salud Reproductiva',
  'Salud-enfermedad',
  'Salud sexual',
  'MÃ©todos anticonceptivos',
  'Desarrollo embrionario en humanos',
  'Materia y factura',
  'Textura',
  'Plasticidad',
  'ExploraciÃ³n ',
  'ExperimentaciÃ³n',
  'Espacio-forma: distribuciÃ³n, organizaciÃ³n y tensiones en el campo plÃ¡stico',
  'RepresentaciÃ³n de la tridimensiÃ³n',
  'Luz-color: valor, tono, saturaciÃ³n, luminosidad',
  'Imagen Ãºnica y reproductibilidad seriada',
  'CirculaciÃ³n y reproducciÃ³n grÃ¡fica',
  'ConstrucciÃ³n de la mirada, percepciÃ³n y conocimiento',
  'ObservaciÃ³n y anÃ¡lisis de producciones',
  'ObservaciÃ³n y anÃ¡lisis de las obras',
  'Patrimonio artÃ­stico'
];

export const temas = [
  'Tablas',
  'GrÃ¡ficos',
  'Expresiones Algebraicas',
  'Teorema',
  'ConstrucciÃ³n',
  'PerÃ­metro',
  'Ãrea',
  'FÃ³rmulas',
  'Operaciones',
  'Equivalencias',
  'Representaciones',
  'Teorema',
  'ConstrucciÃ³n',
  'PerÃ­metro',
  'Ãrea',
  'Textos Narrativos',
  'Textos expositivos',
  'Textos argumentativos',
  'GramÃ¡tica',
  'Textos Ficcionales ',
  'Textos No Ficcionales',
  'RecomendaciÃ³n',
  'ReseÃ±as',
  'OpiniÃ³n',
  'Coherencia',
  'CohesiÃ³n',
  'MonografÃ­a',
  'Guiones',
  'Poemas',
  'Microrelatos',
  'saludar / despedirse ' ,
  'Presentarse',
  'Agradecer',
  'Invitar',
  'Aceptar/rechazar una invitaciÃ³n',
  'InformaciÃ³n personal',
  'Pedir/ofrecer ayuda',
  'Pedir disculpas',
  'Expresar gustos y preferencias',
  'Pedir permiso',
  'Preguntar significado',
  'Describir',
  'Dar y seguir instrucciones',
  'Expresar opiniones',
  'Expresar sentimientos'
];

export const capacidades = [
  'ResoluciÃ³n de problemas',
  'Compartir ideas',
  'AceptaciÃ³n del error',
  'Pensamiento crÃ­tico',
  'Aprender a aprender',
  'Trabajo con otros',
  'Compromiso y responsabilidad',
  'Arte, cultura y patrimonio',
  'Creatividad e innovaciÃ³n',
  'ParticipaciÃ³n responsable y solidaria',
  'Juventud, desarrollo y trabajo',
  'Bienestar, salud y cuidado personal',
  'Ambiente y desarrollo sostenible',
  'ExpresiÃ³n de ideas',
  'TÃ©cnicas de Estudio',
  'AlfabetizaciÃ³n Digital',
  'Competencias Digitales',
  'Conocimiento TÃ©cnico',
  'ColaboraciÃ³n'
];
